module.exports = __webpack_public_path__ + "img/AuditEngineLogo.525cb56c.png";